export default "__VITE_ASSET__CemmVRYo__$_?url__"